var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34.129,
    viewBox: "0 0 34 34.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "callline",
    transform: "translate(-0.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(0.912 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M7.8,22.687A36.207,36.207,0,0,0,19.845,32.12a18.744,18.744,0,0,0,6.74,1.994c.163.007.318.014.481.014a5.581,5.581,0,0,0,4.328-1.86.154.154,0,0,0,.028-.035,18.223,18.223,0,0,1,1.365-1.414c.332-.318.672-.651,1-.99a3.415,3.415,0,0,0-.014-5.085l-4.25-4.25a3.44,3.44,0,0,0-2.489-1.146,3.556,3.556,0,0,0-2.518,1.139l-2.532,2.532c-.233-.134-.474-.255-.7-.368a8.745,8.745,0,0,1-.778-.424A26.794,26.794,0,0,1,14.1,16.4a15.43,15.43,0,0,1-2.164-3.451c.665-.6,1.287-1.231,1.888-1.846.212-.219.431-.438.651-.658A3.625,3.625,0,0,0,15.651,7.9a3.6,3.6,0,0,0-1.174-2.546L12.37,3.246c-.248-.248-.481-.488-.721-.735-.467-.481-.955-.976-1.436-1.421A3.526,3.526,0,0,0,7.724,0,3.63,3.63,0,0,0,5.206,1.1L2.561,3.741A5.434,5.434,0,0,0,.942,7.22a13.088,13.088,0,0,0,.983,5.658A32.914,32.914,0,0,0,7.8,22.687ZM2.667,7.369a3.741,3.741,0,0,1,1.124-2.4L6.423,2.334a1.9,1.9,0,0,1,1.3-.6A1.807,1.807,0,0,1,9,2.348c.474.438.919.9,1.4,1.386.24.248.488.5.735.75L13.24,6.591A1.92,1.92,0,0,1,13.9,7.913a1.92,1.92,0,0,1-.665,1.322c-.219.219-.438.446-.658.665-.658.665-1.273,1.294-1.952,1.9l-.035.035a1.383,1.383,0,0,0-.354,1.57c.007.021.014.035.021.057A16.644,16.644,0,0,0,12.745,17.5,28.28,28.28,0,0,0,19.562,23.7a10.122,10.122,0,0,0,.933.509,8.745,8.745,0,0,1,.778.424c.028.014.05.028.078.042a1.478,1.478,0,0,0,.686.177,1.5,1.5,0,0,0,1.054-.481l2.645-2.645A1.872,1.872,0,0,1,27.03,21.1a1.776,1.776,0,0,1,1.252.629l4.264,4.257a1.705,1.705,0,0,1-.021,2.666c-.3.318-.608.622-.941.941a20.365,20.365,0,0,0-1.478,1.535,3.883,3.883,0,0,1-3.034,1.287c-.12,0-.248-.007-.368-.014a17.029,17.029,0,0,1-6.1-1.825A34.4,34.4,0,0,1,9.145,21.6a31.5,31.5,0,0,1-5.587-9.3A11.406,11.406,0,0,1,2.667,7.369Z",
    transform: "translate(-0.912 0)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e7884e46d7b9086015fe1e33781cbeb8.svg";
export { ForwardRef as ReactComponent };